import {
  DataExtractionFailedBadge,
  DataExtractionInProgressBadge,
  DataExtractionPendingBadge,
  ProcessingFailedBadge,
  ProcessingInProgressBadge,
  SuccessBadge,
} from '../StatusBadges/BulkProvisioningStatusBadges.tsx';
import {
  PROVISIONING_STATUS_LABEL,
  ProvisioningStatusLabel,
} from '@/activityLog/bulkProvisioning/constants/provisioningStatus.ts';
import { CellLayout } from 'common/components/ConfigurableTable/Components/Cells/CellLayout.tsx';

export type StatusBadgeCellProps = {
  value: ProvisioningStatusLabel;
};

const STATUS_BADGE_MAP = {
  [PROVISIONING_STATUS_LABEL.PROCESSING_SUCCEED]: SuccessBadge,
  [PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_FAILED]: DataExtractionFailedBadge,
  [PROVISIONING_STATUS_LABEL.PROCESSING_FAILED]: ProcessingFailedBadge,
  [PROVISIONING_STATUS_LABEL.PROCESSING_IN_PROGRESS]: ProcessingInProgressBadge,
  [PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_IN_PROGRESS]: DataExtractionInProgressBadge,
  [PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_PENDING]: DataExtractionPendingBadge,
} as const;

export const StatusBadgesCell = ({ value }: StatusBadgeCellProps) => {
  const StatusBadge = STATUS_BADGE_MAP[value];

  return (
    <CellLayout>
      <StatusBadge />
    </CellLayout>
  );
};
